export default __webpack_public_path__ + "static/media/patrick-fore-0gkw_9fy0eQ-unsplash.ad38aed5.jpg";